import store from '@/store';

export default function redirectToLocation(loc: string, isVueRoute?: boolean): void {
    let checkoutUrl;

    if (process.env.NODE_ENV !== 'production') {
        checkoutUrl = '/';
    } else {
        checkoutUrl = `${store.state.options.full_base_url}checkout/`;
    }

    let locHref: string;

    if (isVueRoute) {
        locHref = `${checkoutUrl}#/${loc}`;
        setTimeout(() => {
            window.location.reload();
        }, 500);
    } else {
        locHref = store.state.options.full_base_url + loc.replace(/^\//, '');
    }

    window.location.href = locHref;
}

export function getFullUrl(path: string): string {
    return store.state.options.full_base_url + path.replace(/^\//, '');
}
